import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { ITaskForm } from 'src/app/components/task-form/task-form.component';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { SwalService } from 'src/app/services/swal/swal.service';
import { TaskService } from 'src/app/services/task/task.service';
import { LocationUIService } from 'src/app/services/location-ui/location-ui.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { take, takeUntil } from 'rxjs/operators';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-list-task',
  templateUrl: './list-task.component.html',
  styleUrls: ['./list-task.component.sass']
})
export class ListTaskComponent implements OnInit, OnDestroy {
  unsubber: Subject<boolean> = new Subject<boolean>()

  tasks: ITaskForm[]
  currLoc: any;
  canCreate: boolean;

  constructor(
    private taskServ: TaskService,
    private dataService: DataService,
    private router: Router,
    private swalService: SwalService,
    private locationUiService: LocationUIService,
    private _t: TranslateService,
    private toastr: ToastrService,
    private locationStore: LocationStoreService
  ) {
    // this.dataServiceSub = this.dataService.currLocation$.subscribe(res => {
    //   if (res.id) {
    //     this.currLoc = res
    //     this.taskServiceSub = this.taskServ.findAll([{ key: 'filtered[0][key]', val: 'location' }, { key: 'filtered[0][val]', val: res.id }])
    //       .subscribe((res: { data: ITaskForm[] }) => {
    //         if (!res) return
    //         this.tasks = res.data
    //       })
    //   }
    // })
  }

  ngOnInit(): void {
    const permissions = JSON.parse(localStorage.getItem(LS.currentUser)).permissions;
    this.canCreate = permissions ? permissions['create:any.task'] : false;
    this.locationStore.currLocation$.pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe(res => {
        if (res.id) {
          this.currLoc = res

          if (this.currLoc.tasks?.length) {
            this.tasks = this.currLoc.tasks
          } else {
          }
          this.getTask()
        }
      })
  }

  getTask() {
    const res = this.currLoc
    this.taskServ.findAll([{ key: 'filtered[0][key]', val: 'location' }, { key: 'filtered[0][val]', val: res.id }])
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res: { data: ITaskForm[] }) => {
        if (!res) return
        this.tasks = res.data.map((task) => {
          const assigner = task.assigner as any
          task.assigner = assigner?.avatar?.url || '/assets/images/avatar.svg'
          return task;
        })
        setTimeout(() =>{
          this.currLoc.tasks = this.tasks
        }, 100)
        this.currLoc.tasks = this.tasks
      })
  }

  onClickTask(task) {
    this.router.navigate(['/projects', this.currLoc.id, 'details', 'tasks', 'edit', task.id])
  }

  onDelete(taskid) {
    this.swalService.confirmDialog((swalRes) => {
      this.taskServ.remove(taskid).pipe(takeUntil(this.unsubber.asObservable())).subscribe(res => {
        this.getTask()
        const undoMsg = this._t.instant('Tap HERE to undo')
        this.toastr
          .info(undoMsg, '', {
            progressBar: true,
            timeOut: 7000,
            enableHtml: true,
          })
          .onTap.pipe(take(1))
          .subscribe(() => {
            this.taskServ.restore(taskid).pipe(takeUntil(this.unsubber.asObservable())).subscribe(restoreRes => {
              this.getTask()
            })
          })
        // swalRes();
      })
    })
  }

  ngOnDestroy() {
    this.unsubber.next(true);
    this.unsubber.unsubscribe();
  }
}
